import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=ae0b5b32&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\dslx464\\Desktop\\workspace\\chatgpt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ae0b5b32"]])

export default __exports__